const PaymentChannelIDEnum = require('@/lib/Channels/PaymentChannelIDEnum');
const PaymentChannelNameEnum = require('@/lib/Channels/PaymentChannelNameEnum');
const { populate } = require('@/functions/objects');
const { toInt, toString } = require('@/functions/transform');

class PaymentChannel {
    constructor(data = {}) {
        /**
         * @type {number|undefined}
         */
        this.ID = undefined;

        /**
         * @type {string|undefined}
         */
        this.name = undefined;

        populate(this, data);
    }

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'paymentChannelID'],
                transform: toInt,
            },
            name: toString,
        };
    }

    /**
     * @return {boolean}
     */
    isProMenu() {
        return this.ID === PaymentChannelIDEnum.PRO_MENU;
    }

    /**
     * Creates a PaymentChannel instance for the given ID
     *
     * @param {number|string} ID
     *
     * @return {PaymentChannel}
     */
    static fromID(ID) {
        const channelID = toInt(ID);

        return new PaymentChannel({
            ID: channelID,
            name: PaymentChannelNameEnum[channelID],
        });
    }
}

module.exports = PaymentChannel;
